<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('studentEnrollment.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('studentEnrollment.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between ts-whitespace-no-wrap">
          <div>
            <ts-button
              color="info"
              outline
              @click="$router.push({ name: 'student-enrollment-create' })"
              >{{ $t('add_new') }}</ts-button
            >
            <ts-button class="ml-2" @click.prevent="promotionClass">
              {{ $t('studentEnrollment.promotionClass') }}
            </ts-button>
            <ts-button class="ml-2" @click.prevent="gradeAccelerate">
              {{ $t('studentEnrollment.accelerate') }}
            </ts-button>
          </div>
          <div>
            <div class="d-flex">
              <ts-input
                v-model="search"
                :placeholder="$t('search')"
                style="width: 250px"
                class="inline-block"
              />
              <ts-button
                outline
                class="ml-2"
                v-tooltip="$t('invoice.filter')"
                @click.prevent="visible = true"
              >
                <i class="fa fa-filter"></i>
              </ts-button>
              <a-drawer
                :title="$t('invoice.filter')"
                placement="right"
                :closable="false"
                :visible="visible"
                @close="() => (visible = false)"
                :zIndex="1020"
                width="300px"
              >
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <ts-branch-filter
                        @filter="value => (branch_id = value)"
                      />
                    </div>
                  </div>
                </div>
                <!-- <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <ts-checkbox v-model="history" class="ml-2">
                        {{ $t('studentEnrollment.history') }}
                      </ts-checkbox>
                    </div>
                  </div>
                </div> -->
                <ts-academic-year-filter @filter="acYearFetch" />
                <div class="row ts-mt-2">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label class="ts-text-xs">{{
                        $t('studentEnrollment.status')
                      }}</label>
                      <a-select
                        v-model="history"
                        class="ts-w-full"
                        mode="multiple"
                        @change="fetchData()"
                      >
                        <a-select-option :value="1">
                          {{ $t('studentEnrollment.current') }}
                        </a-select-option>
                        <a-select-option :value="2">
                          {{ $t('studentEnrollment.history') }}
                        </a-select-option>
                        <a-select-option :value="3">
                          {{ $t('studentEnrollment.next') }}
                        </a-select-option>
                      </a-select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <div
                        class="ts-w-full ts-border ts-border-gray-400 ts-p-2 ts-rounded"
                      >
                        <label class="ts-uppercase">{{
                          $t('studentEnrollment.studentStatus')
                        }}</label>
                        <ts-checkbox
                          v-model="student_status_id"
                          :value="2"
                          class="ml-2"
                        >
                          {{ $t('studentEnrollment.dropedOut') }}
                        </ts-checkbox>
                        <ts-checkbox
                          v-model="student_status_id"
                          :value="3"
                          class="ml-2"
                        >
                          {{ $t('studentEnrollment.suspend') }}
                        </ts-checkbox>
                        <ts-checkbox
                          v-model="student_status_id"
                          :value="4"
                          class="ml-2"
                        >
                          {{ $t('studentEnrollment.terminated') }}
                        </ts-checkbox>
                      </div>
                    </div>
                  </div>
                </div>
              </a-drawer>
            </div>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="scrollable">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :rowGroup="{
            field: 'academic_class.sub_program.acps_name_foreign'
          }"
        >
          <template v-slot="{ record }">
            <td class="ts-whitespace-no-wrap">
              {{ record.academic_class.branch.branch_name_en }}
            </td>
            <td>{{ record.student_profile.card_number }}</td>
            <td class="ts-whitespace-no-wrap">
              {{ record.student_profile.full_name_en }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.academic_class.grade.grade_name_foreign }}
            </td>
            <td class="ts-whitespace-no-wrap">
              <p>
                {{
                  record.academic_class
                    ? record.academic_class.class_name
                    : null
                }}
              </p>
              <p>
               
                {{
                  record.academic_class
                    ? record.academic_class.academic_study_time
                      ? record.academic_class.academic_study_time.study_time
                      : ''
                    : ''
                }}
              </p>
              <p>
                {{
                  record.academic_class
                    ? record.academic_class.teacher
                      ? record.academic_class.teacher.full_name_en
                      : ''
                    : ''
                }}
              </p>
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.academic_class.academic_study_time.study_time }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.academic_class.academic_term.term_name }}
            </td>
            <td class="text-center">
              <span class="label label-green" v-if="record.ac_status_id == 1"
                >Current</span
              >
              <span
                class="label label-secondary"
                v-if="record.ac_status_id == 2"
                >History</span
              >
              <span class="label label-info" v-if="record.ac_status_id == 3"
                >Next</span
              >
            </td>
            <td class="text-center">
              {{ record.status }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.academic_class.academic_year.ac_year }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{
                record.modified_by ? record.modified_by.employee.name_en : null
              }}
            </td>
            <td class="kh-font text-center ts-whitespace-no-wrap">
              <a
                v-if="record.ac_status_id != 2"
                href="#"
                title="Edit"
                class="mr-2 text-primary"
                @click.prevent="edit(record)"
              >
                <i class="fas fa-edit"></i>
              </a>
              <a
                v-if="record.ac_status_id != 2"
                href="#"
                title="Delete"
                class="text-danger"
                @click.prevent="destroy(record)"
                :disabled="record._deleting"
              >
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fas fa-trash" v-else></i>
              </a>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash'
import updateClass from './components/update-class'
// import classForward from './components/class-forward'
import classForward from './components/class-forward-v1'
import promotionClass from './components/class-promotion-v1.vue'
import gradeAccelerate from './components/grade-accelerate.vue'

export default {
  name: 'studentEnrollmentIndex',
  components: {
    updateClass,
    classForward,
    promotionClass,
    gradeAccelerate
  },
  data() {
    return {
      loading: false,
      visible: false,
      branch_id: []
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('studentEnrollment', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.studentEnrollment.search
      },
      set(newValue) {
        this.$store.commit('studentEnrollment/SET_SEARCH', newValue)
        this.$store.commit('studentEnrollment/RESET_CURRENT_PAGE')
      }
    },
    student_status_id: {
      get() {
        return this.$store.state.studentEnrollment.student_status_id
      },
      set(newValue) {
        this.$store.commit(
          'studentEnrollment/SET_STUDENT_STATUS_VALUE',
          newValue
        )
      }
    },
    history: {
      get() {
        return this.$store.state.studentEnrollment.status
      },
      set(newValue) {
        this.$store.commit('studentEnrollment/SET_STATUS_VALUE', newValue)
      }
    },
    is_external() {
      return this.$store.state.authUser.is_external
    },
    columns: function() {
      return [
        { name: this.$t('studentEnrollment.branchName'), style: 'width:14%;' },
        { name: this.$t('studentEnrollment.studentCard') },
        { name: this.$t('studentEnrollment.studentName') },
        { name: this.$t('studentEnrollment.gradeName') },
        { name: this.$t('studentEnrollment.className') },
        { name: this.$t('studentEnrollment.studyTime') },
        { name: this.$t('studentEnrollment.termName') },
        {
          name: this.$t('studentEnrollment.status'),
          style: 'text-align:center'
        },
        {
          name: this.$t('studentEnrollment.studentStatus'),
          style: 'text-align:center'
        },
        { name: this.$t('studentEnrollment.academicYear') },
        { name: this.$t('studentEnrollment.modifiedBy') },
        { name: this.$t('actions'), style: 'width:7%; text-align:center' }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch(
          'studentEnrollment/fetch',
          Object.assign(
            {
              branch_id: this.branch_id
            },
            { ...attributes }
          )
        )
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.$modal.show(
        updateClass,
        {
          edit_data: record
        },
        {
          height: 'auto',
          width: '30%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        },
        {
          'before-close': this.fetchData
        }
      )
    },
    async destroy(record) {
      if (await this.$confirmModal.danger(this.$t('are_you_sure_to_delete'))) {
        record._deleting = true
        this.$store
          .dispatch('studentEnrollment/destroy', record.st_class_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    },
    promotionClass() {
      this.$modal.show(
        promotionClass,
        {},
        {
          height: 'auto',
          width: '40%',
          scrollable: true,
          // draggable: '.form-header',
          clickToClose: false
        },
        {
          'before-close': this.fetchData
        }
      )
    },
    acYearFetch(value) {
      this.$store.commit('studentEnrollment/SET_ACADEMIC_YEAR_VALUE', value)
      this.fetchData()
    },
    gradeAccelerate(){
      this.$modal.show(
        gradeAccelerate,
        {},
        {
          height: 'auto',
          width: '40%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        },
        {
          'before-close': this.fetchData
        }
      )
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search, branch_id: this.branch_id })
    }, 500),
    branch_id: debounce(function(value) {
      this.fetchData({ branch_id: value })
    }, 500),
    student_status_id: debounce(function() {
      this.fetchData({ branch_id: this.branch_id })
    }, 500),
    history: debounce(function() {
      this.fetchData({ branch_id: this.branch_id })
    }, 500),
    is_external: debounce(function() {
      this.fetchData({ branch_id: this.branch_id })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('studentEnrollment/RESET_STATE')
    next()
  }
}
</script>
<style>
.scrollable {
  height: 700px;
  overflow-y: scroll;
}
</style>
